import classNames from "classnames";
import styles from "./Heading.module.css";
import type { HTMLAttributes, PropsWithChildren, JSX } from "react";

type HeadingProps = PropsWithChildren<{
  as: "h1" | "h2" | "h3";
  id?: HTMLAttributes<HTMLElement>["id"];
  reducedGap?: boolean;
  className?: string;
}>;

const Heading = (props: HeadingProps): JSX.Element => {
  const { as, id, reducedGap = false, children, className } = props;

  const Tag: keyof JSX.IntrinsicElements = as;

  const headingClassNames = classNames(styles.heading, styles[as], {
    [styles.reducedGap]: reducedGap,
    [className ?? ""]: !!className,
  });

  return (
    <Tag id={id} className={headingClassNames}>
      {children}
    </Tag>
  );
};

export { Heading };
